import { render, staticRenderFns } from "./LocaleDropdown.vue?vue&type=template&id=4e7403d0&scoped=true&lang=pug"
import script from "./LocaleDropdown.vue?vue&type=script&lang=js"
export * from "./LocaleDropdown.vue?vue&type=script&lang=js"
import style0 from "./LocaleDropdown.vue?vue&type=style&index=0&id=4e7403d0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7403d0",
  null
  
)

export default component.exports